import React, { useMemo } from 'react'
import Visualization from './Visualization'

const IndicatorDetails = ({
  subTopic,
  setLoadingStates,
  loadingStates,
  subTopicIndex,
  indicatorRedirectUrl,
  featuredDatasetsData,
}) => {
  const selectedIndicator = useMemo(
    () => subTopic.indicators.find((obj) => obj.isSelected),
    [subTopic.indicators]
  )

  return (
    <div
      className="swiper-wrapper"
      id="swiper-wrapper-a82b45bb8cda9f10f"
      aria-live="polite"
    >
      {selectedIndicator && (
        <div key={`${selectedIndicator.id}-visualization`}>
          <Visualization
            key={`${selectedIndicator.id}-${selectedIndicator.datasetId}`}
            visType={selectedIndicator.charts.theme}
            indicatorId={selectedIndicator.id}
            visualization={selectedIndicator.visualization}
            datasetId={selectedIndicator.datasetId}
            datasetName={selectedIndicator.datasetName}
            sources={selectedIndicator.sources}
            name={selectedIndicator.name}
            isLoading={loadingStates[selectedIndicator.id]}
            onLoad={() =>
              setLoadingStates((prev) => ({
                ...prev,
                [selectedIndicator.id]: false,
              }))
            }
            longDefination={selectedIndicator.longDefination}
            indicatorRedirectUrl={indicatorRedirectUrl}
            subTopicIndex={subTopicIndex}
            featuredDatasetsData={featuredDatasetsData}
          />
        </div>
      )}
    </div>
  )
}

export default IndicatorDetails
